import { useState, useEffect } from 'react';
import CreateAction from '../../../components/operational/createAction';
import { translate } from '../../../utils/language';

const TotalRevenueTab = ({ dateRange }) => {
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [errorMessage, setErrorMessage] = useState('');
  const [currencySymbol, setCurrencySymbol] = useState('');

  const getDatas = async () => {
    const response = await CreateAction({
      method: 'POST',
      data: { dateRange },
      path: `/report/totalRevenue`,
      showPreLoader: true,
      isFileUploading: false,
      hideToastMessages: true,
    });

    if (response?.error) return;
    if (response?.result?.resultData?.firebaseService === 'NEED_PERMISSION') {
      setErrorMessage('NEED_PERMISSION');
      return;
    }
    if (!response?.result?.resultData?.rows) return setErrorMessage('NO_DATA')

    setErrorMessage('');
    setCurrencySymbol(response?.result?.resultData?.metadata?.currencyCode);

    const resultData = Object.entries(response?.result?.resultData?.rows || {}).map(([date, value]) => ({
      date,
      value: Number(value),
    }));

    const total = resultData.reduce((acc, item) => acc + item.value, 0);
    setTotalRevenue(total);
  };

  useEffect(() => {
    if (dateRange.startDate && dateRange.endDate) getDatas();
  }, [dateRange]);

  return (
    <div className="w-[100%] px-[50px] py-[25px] flex flex-col" style={{ borderRight: '1px solid #E5E5E5' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ fontSize: '17px', color: '#494949' }}>Toplam Satış</div>
      </div>
      {errorMessage ? (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div className="text-red-500 text-center">
            {translate(errorMessage)}
          </div>
        </div>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ fontSize: '27px', color: '#494949' }}>
            {currencySymbol === 'USD' ? '$ ' : '₺ '}
            {totalRevenue?.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
          </div>
        </div>
      )}
    </div>
  );
};

export default TotalRevenueTab;
